import { Radio } from 'components/RadioGroup'
import { RadioBullet } from 'components/RadioGroup/RadioBullet'
import { Text } from 'blaze-ui/Text/Text'
import { ReactNode } from 'react'
import { RadioProps } from 'components/RadioGroup/Types'
import Styles from './MediaTypeField.module.scss'

interface RadioCardProps extends Omit<RadioProps, 'children'> {
  icon: ReactNode
  label: string
}

export const RadioCard = ({ icon, label, ...props }: RadioCardProps) => (
  <Radio {...props} hideRadio className={Styles.card} classNames={{ selected: Styles.selected }}>
    {(radioProps) => (
      <>
        <div className={Styles.bullet}>
          <RadioBullet {...radioProps} size={20} />
        </div>
        <div className={Styles.labelImageContainer}>
          <div className={Styles.image}>{icon}</div>
          <div className={Styles.label}>
            <Text variant="smallList">{label}</Text>
          </div>
        </div>
      </>
    )}
  </Radio>
)
